<template>
<div class="drawerWrap dangerDrawer">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="隐患标题" prop="">
        <el-input v-model="form.title" minlength="1" maxlength="20" :disabled="true" placeholder="请输入隐患名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="处理时间" prop="">
        <el-date-picker
          v-model="form.handleTime"
          type="datetime"
          placeholder="选择日期时间"
          default-time="12:00:00">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item label="现场情况" prop="scene">
        <el-input type="textarea" v-model="form.scene" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="整改意见" prop="opinion">
        <el-input type="textarea" v-model="form.opinion" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="处理结果" prop="result">
        <el-input type="textarea" v-model="form.result" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
      <div class="unitImg">
        <el-form-item label="处理图片">
          <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" :before-upload="beforeAvatarUpload" action :disabled="disabled" :limit="1" list-type="picture-card" :http-request="handleHttpRequest" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :append-to-body='true' :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </div>
      <el-form-item label="隐患处理签名" prop="signPicture">
        <!-- <el-button type="primary" @click="dialogVisibles=true">签名</el-button> -->
        <div class="showCons">
          <!-- <div class="title"><span>签名</span></div> -->
          <div class="boardBox" ref="boardBox">
            <canvas ref="board" id="canvas" @mousedown="pcStart" @mousemove="pcMove" @mouseup="pcEnd">
            </canvas>
          </div>
          <div class="bar">
            <!-- <el-button type="primary" @click="getcanvas">确定</el-button> -->
            <el-button @click="clearcanvas" :disabled="isdisabledFn" :style="{background:changeBg?'#FC5C64':'#D1D1D1',color:'#fff'}">清除</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ctx: null,
      point: {
        x: 0,
        y: 0
      },
      moving: false, // 是否正在绘制中且移动
      dialogImageUrl: '',
      // imgData: null,
      dialogVisible: false,
      dialogVisibles: false,
      disabled: false,
      fileList: [],
      httpRequestImg: false, //展示单个图片
      left: "left",
      show: "添加",
      // loading: false,
      form: {
        title: '', //
        scene: '', //现场情况
        opinion: '', //整改意见
        result: '', //处理结果
        dangerHandleOriginal: '', //隐患处理照片原图
        signPicture: '', //隐患处理签名照片
      },
      formRules: {
        // name: [
        //   {
        //     required: true,
        //     validator: this.validateDeviceName,
        //     trigger: "blur"
        //   }
        // ],
        result: [{
          required: true,
          validator: this.validateResult,
          trigger: "blur"
        }],
        // location: [{
        //   required: true,
        //   validator: this.validateLocation,
        //   trigger: "blur"
        // }],
        // deviceType:[{
        //  required: true,
        //   message: "请选择隐患类型",
        //   trigger: ["change"] 
        // }],
        // zone:[{
        //   required: true,
        //   message: "请选择安装区域",
        //   trigger: ["blur"] 
        // }]
      },
      changeBg: false,
      isdisabledFn: true,
    }
  },
  created() {
    console.log(this.handleType)
    console.log(this.editData)
    // console.log(this.baseUrlAddr)
  },
  mounted() {
    this.init();
    let board = this.$refs.board; // 获取DOM
    board.width = this.$refs.boardBox.offsetWidth; // 设置画布宽
    board.height = this.$refs.boardBox.offsetHeight; // 设置画布高
    this.ctx = board.getContext('2d'); // 二维绘图
    this.ctx.strokeStyle = '#ff0000'; // 颜色
    this.ctx.lineWidth = 3; // 线条宽度
  },
  // inject:['pinit','pinitdata'],
  methods: {
    init() {
      if (this.handleType == 'add') {} else if (this.handleType == 'edit') {
        console.log(this.editData)
        if (this.editData.id) {
          this.form = {
            title: this.editData.title,
            // dangerOriginalPhoto: this.editData.dangerOriginalPhoto,
          }
          // if (this.editData.dangerOriginalPhoto) {
          //   this.httpRequestImg=true           
          //     let obj = new Object();
          //     obj.url =this.baseUrlAddr+ this.editData.dangerOriginalPhoto;
          //     this.fileList.push(obj);
          //   }else{
          //     this.httpRequestImg=false
          //   }
        }
      }
    },
    // 
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      //确认
      //绘画转图片
      document.getElementById("canvas").toDataURL("image/png");
      let that = this
      document.getElementById("canvas").toBlob(async (blobObj) => {
        var file1 = new File([blobObj], "pic.png", {
          type: blobObj.type,
          lastModified: Date.now(),
        });
        that.form.signPicture = file1
        let formDates = {
          // handleTime: this.editData.createTime,
          result: that.form.result, //处理结果
          scene: that.form.scene, //现场情况
          opinion: that.form.opinion, //整改意见
        };
        const formData = new FormData();
        if (that.form.dangerHandleOriginal) {
          formData.append("dangerHandleOriginal", that.form.dangerHandleOriginal)
        }
        if (that.form.signPicture) {
          formData.append("signPicture", that.form.signPicture)
        }
        // console.log(formDates);
        that.$refs["form"].validate(valid => {
          if (!valid) {
            return that.msg.error("请按要求完善表单信息");
          }
          that.$emit("update:loading", true);

          if (that.handleType == 'add') {

          } else if (that.handleType == 'edit') {
            if (that.form.signPicture == '') {
              that.msg.warn("请确定签名")
              return
            }
            let source = {
              dangerId: that.editData.id,
            }
            let editDatas = Object.assign(formDates, source);
            that.request.putParamsForm("/front/danger/handle", editDatas, formData).then(res => {
              console.log(res);
              that.$emit("update:loading", false);
              if (res.code == 200) {
                that.msg.success('隐患处理成功')
                that.$emit('confirm', res.code)
              } else if (res.code == 500) {
                that.msg.warn(res.msg);
              }
            });
          }
          // this.$emit("confirm", this.form);
          //   this.storage.setSession("headImg", this.form.img);
        });
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleHttpRequest(obj) {
      this.form.dangerHandleOriginal = obj.file;
      console.log(obj.file);
      this.httpRequestImg = true;
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handleRemove(file, fileList) {
      this.httpRequestImg = false;
      this.dialogImageUrl = "";
      this.fileList = [];
    },
    validateDeviceName(rule, value, callback) {
      if (value === "" || value === null) {
        callback(new Error("隐患名不能为空"));
      } else if (value.length > 20) {
        callback(new Error("隐患名长度不能超过20个字符"));
      } else if (value.length < 1) {
        callback(new Error("隐患名长度不能少于1个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("隐患名不合法,请输入由_或字母或汉字或数字组成！")
          );
        } else {
          callback();
        }
      }
    },
    validateResult(rule, value, callback) {
      console.log(value);
      if (value === "" || value === null || value == undefined) {
        callback(new Error("处理结果不能为空"));
      } else if (value.length < 1) {
        callback(new Error("处理结果大于1个字符"));
      } else if (value.length > 500) {
        callback(new Error("处理结果小于500个字符"));
      } else {
        callback();
      }
    },
    validateLocation(rule, value, callback) {
      if (value === "" || value === null) {
        callback(new Error("安装位置不能为空"));
      } else if (value.length > 20) {
        callback(new Error("安装位置长度不能超过20个字符"));
      } else if (value.length < 1) {
        callback(new Error("安装位置长度不能少于1个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("安装位置不合法,请输入由_或字母或汉字或数字组成！")
          );
        } else {
          callback();
        }
      }
    },
    // 鼠标按下(开始)
    pcStart(e) {
      let x = e.offsetX,
        y = e.offsetY; // 获取鼠标在画板（canvas）的坐标
      this.point.x = x;
      this.point.y = y;
      this.ctx.beginPath();
      this.moving = true;
    },
    // 鼠标移动（移动中...）
    pcMove(e) {
      if (this.moving) {
        let x = e.offsetX,
          y = e.offsetY; // 获取鼠标在画板（canvas）的坐标
        this.ctx.moveTo(this.point.x, this.point.y); // 把路径移动到画布中的指定点，不创建线条(起始点)
        this.ctx.lineTo(x, y); // 添加一个新点，然后创建从该点到画布中最后指定点的线条，不创建线条
        this.ctx.stroke(); // 绘制
        this.point.x = x, this.point.y = y; // 重置点坐标为上一个坐标
      }
    },
    // 鼠标松开（结束）
    pcEnd() {
      if (this.moving) {
        this.ctx.closePath(); // 停止绘制
        this.moving = false; // 关闭绘制开关
        this.changeBg = true
        this.isdisabledFn = false
      }
    },
    /*     getcanvas() {
          console.log(` document.getElementById("canvas").toDataURL("image/png")`, document.getElementById("canvas").toDataURL("image/png"))
          console.log(`this.form.signPicture`, this.form.signPicture)

              //绘画转图片
                document.getElementById("canvas").toDataURL("image/png");
                let that = this
                document.getElementById("canvas").toBlob(async (blobObj) => {
                   var file1 = new File([blobObj], "pic.png", {
                      type: blobObj.type,
                      lastModified: Date.now(),
                   });
                   console.log(file1)
                   that.form.signPicture=file1
                });
                 if(this.form.signPicture){
               this.msg.warn("请先进行签名")
               return
             } 
          console.log(`  that.form.signPicture`, this.form.signPicture)
        }, */
    clearcanvas() {
      var c = document.getElementById("canvas");
      var cxt = c.getContext("2d");
      c.height = c.height;
      this.ctx.lineWidth = 3;
      this.changeBg = false
      this.ctx.strokeStyle = '#ff0000'; // 颜色
      this.isdisabledFn = true
      this.form.signPicture = ""
    },
  }
};
</script>

<style lang="scss" scoped>
.jSignature {
  margin: 10px auto;
  padding: 0px;
  border: 1px dashed #aaa;
  width: calc(100vw - 60px);
  height: calc(100vh - 200px);
  max-height: 426px;
  max-width: 900px;
  touch-action: none;
  background-color: rgb(246, 246, 246);
  display: block;
  outline: none;
}

.showCons {
  .boardBox {
    border: 1px solid #ccc;
  }
}
</style><style lang="scss">
.dangerDrawer {
  .drawerBody {
    .el-transfer {
      .el-transfer-panel {
        text-align: left;
        width: 250px;
      }

      .el-transfer__buttons {
        width: 65px;
        text-align: center;

        .el-button {
          margin: 5px 0;
          width: 56px;
        }
      }
    }

    .el-switch {
      width: 100%;
    }

    .el-image {
      margin-right: 20px;
    }

    .el-form {
      margin-top: 20px;

      .el-form-item__label {
        line-height: 50px;
      }

      .el-form-item__content {
        line-height: 50px;
      }

      .el-select {
        width: 100%;
      }

      .el-textarea {
        width: 100%;

        .el-textarea__inner {
          height: 80px !important;
          line-height: 20px;
          color: #6e6e6e;
          font-size: 14px;
          font-weight: 400;
        }
      }

      .el-input {
        width: 100%;

        .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .drawerBody .el-form-item__label,
    .sp {
      color: #6e6e6e;
    }

    .unitImg {
      .el-form-item {
        width: 100%;
      }
    }
  }
}
</style>
